"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SongMetadata = void 0;
class SongMetadata {
    constructor(plugin) {
        this.pluginName = plugin.pluginName;
        this.value = {};
    }
    toObject() {
        return this.value;
    }
}
exports.SongMetadata = SongMetadata;
//# sourceMappingURL=SongMetadata.js.map